import { useCallback, useState, type ReactNode } from 'react';
import { ErrorContext } from '@/context/errorContext';
import ErrorToast from '@/components/ErrorToast/ErrorToast';

export const ErrorProvider = ({ children }: { children: ReactNode }) => {
  const [message, setMessage] = useState<string | null>(null);

  const pushError = useCallback((msg: string) => setMessage(msg), []);
  const dismiss = useCallback(() => setMessage(null), []);

  return (
    <ErrorContext.Provider value={{ pushError }}>
      {children}
      {message && <ErrorToast message={message} onDismiss={dismiss} />}
    </ErrorContext.Provider>
  );
};
